<svg enable-background="new 0 0 100 100" id="L2" version="1.1" viewBox="0 0 100 100" x="0px"
     xml:space="preserve" xmlns="http://www.w3.org/2000/svg" y="0px" *ngIf="loader">

  <defs>
    <linearGradient
      [attr.x1]="loader.linearGradientPosition.x1"
      [attr.x2]="loader.linearGradientPosition.x2"
      [attr.y1]="loader.linearGradientPosition.y1"
      [attr.y2]="loader.linearGradientPosition.y2"
      id="linear">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </linearGradient>
    <radialGradient [attr.fx]="loader.radialGradientPosition.x"
                    [attr.fy]="loader.radialGradientPosition.y"
                    id="radial">
      <stop *ngFor="let stop of loader.gradientColorValues" [attr.offset]="stop.position"
            [attr.stop-color]="stop.color"/>
    </radialGradient>
  </defs>
  <circle [attr.stroke]="loader.color" cx="50" cy="50" fill="none" r="48" stroke-miterlimit="10" stroke-width="4"/>
  <line [attr.stroke]="loader.color" fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4" x1="50"
        x2="85"
        y1="50"
        y2="50.5">
  <animateTransform
    attributeName="transform"
    dur="2s"
    from="0 50 50"
    repeatCount="indefinite"
    to="360 50 50"
    type="rotate"/>
</line>
  <line [attr.stroke]="loader.color" fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4" x1="50"
        x2="49.5"
        y1="50" y2="74">
  <animateTransform
    attributeName="transform"
    dur="15s"
    from="0 50 50"
    repeatCount="indefinite"
    to="360 50 50"
    type="rotate"/>
</line>
</svg>
